import * as React from "react";
import { useState } from "react";
import { useAuth } from "../auth/AuthProvider";
import Sidebar from "./Sidebar";
import SignInGate from "./SignInGate";
import EntitlementGate from "./EntitlementGate";

type AppShellProps = {
  children: React.ReactNode;
};

export default function AppShell({ children }: AppShellProps) {
  const { user } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  if (!user) {
    return <SignInGate />;
  }

  // Signed in — require an active subscription before the app is usable.
  return (
    <EntitlementGate>
      <div className="min-h-screen bg-white">
        <Sidebar open={sidebarOpen} onToggle={() => setSidebarOpen((o) => !o)} />
        {/* Reserve room for the collapsed rail (48px). When the drawer expands,
            it overlays content via the backdrop — no layout shift on the main pane. */}
        <div className="pl-12">{children}</div>
      </div>
    </EntitlementGate>
  );
}
